import * as React from "react";

import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@components/ui/select";

import { Button } from "@components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@components/ui/dialog";
import { Input } from "@components/ui/input";
import { useToast } from "@components/ui/use-toast";
import { TimeFilterProps } from "./CommonTypes";

const TimeFilter: React.FC<TimeFilterProps> = ({
  customClass = "",
  customValues = [],
  customTimeFrame = false,
  defaultValue = "day",
  onSubmitEvent = null,
  onChangeEvent = null,
  customMessage = "",
}) => {
  const [timeDialogOpen, settimeDialogOpen] = React.useState(false);
  const [fromDate, setFromDate] = React.useState("");
  const [toDate, setToDate] = React.useState("");
  const { toast } = useToast();
  let defValue = [
    ["day", "Last 24 Hours"],
    ["3day", "Last 3 Days"],
    ["7day", "Last 7 Days"],
    ["month", "Last 30 Days"],
    ["2month", "Last 60 Days"],
  ];

  const toggleTimeDialogOpen = (value: string) => {
    if (value === "custom") {
      settimeDialogOpen(true);
    } else {
      if (onChangeEvent) {
        onChangeEvent(value);
      }
    }
  };

  const fromDateChanged = (event: any) => {
    setFromDate(event.target.value);
  };

  const toDateChanged = (event: any) => {
    setToDate(event.target.value);
  };

  const onTimeSubmit = () => {
    if (fromDate == "") {
      toast({
        title: "Error",
        description: "Please select the from date",
        variant: "destructive",
        duration: 2000,
        className: "text-left",
      });
      return;
    }

    if (toDate == "") {
      toast({
        title: "Error",
        description: "Please select the to date",
        variant: "destructive",
        duration: 2000,
        className: "text-left",
      });
      return;
    }

    settimeDialogOpen(false);
    if (onSubmitEvent) {
      onSubmitEvent(
        fromDate.replace("T", " ") + ":00",
        toDate.replace("T", " ") + ":00",
      );
    }
  };

  if (customValues.length > 0) {
    defValue = customValues;
  }

  function showInputPicker(e: any) {
    e.target.showPicker();
  }

  return (
    <div className={`inline-block min-w-48 ${customClass}`}>
      <Select onValueChange={toggleTimeDialogOpen} defaultValue={defaultValue}>
        <SelectTrigger className="w-full rounded-none h-9 text-xs">
          <SelectValue placeholder="Time Frame..." />
        </SelectTrigger>
        <SelectContent>
          <SelectGroup>
            {defValue.map(([value, label]) => (
              <SelectItem key={value} value={value}>
                {label}
              </SelectItem>
            ))}
            {customTimeFrame && (
              <SelectItem
                key="custom"
                onPointerUp={() => toggleTimeDialogOpen("custom")}
                value="custom"
                className="text-xs"
              >
                Custom Timeframe
              </SelectItem>
            )}
          </SelectGroup>
        </SelectContent>
      </Select>
      <Dialog open={timeDialogOpen} onOpenChange={settimeDialogOpen}>
        <DialogContent className="w-auto">
          <DialogHeader>
            <DialogTitle>Custom Timeframe</DialogTitle>
            <DialogDescription>
              {customMessage || "Select custom timeframe"}
            </DialogDescription>
          </DialogHeader>
          <div className="grid gap-4 py-4 text-sm">
            <div className="grid grid-cols-2 gap-4">
              <div className="col-span-1">
                <div>From</div>
                <Input
                  id="fromTime"
                  value={fromDate}
                  type="datetime-local"
                  onClick={(e: any) => showInputPicker(e)}
                  onChange={fromDateChanged}
                />
              </div>
              <div className="col-span-1">
                <div>To</div>
                <Input
                  id="toTime"
                  value={toDate}
                  type="datetime-local"
                  onClick={(e: any) => showInputPicker(e)}
                  onChange={toDateChanged}
                />
              </div>
            </div>
          </div>
          <DialogFooter>
            <Button type="submit" onClick={onTimeSubmit} className="text-white">
              Save changes
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default TimeFilter;
